var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-btn',{attrs:{"large":"","elevation":"3","rounded":"","color":"primary"},on:{"click":_vm.navigateToLoginPage}},[_vm._v(" "+_vm._s(_vm.$t("btn.done"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }